import { IMAGE_URL } from '@/common'
export const DEFAULT_COMPANY_PROFILE_BANNER = `${IMAGE_URL}/company-assets/images/banner-default-company.png`
export const DEFAULT_COMPANY_LOGO = `${IMAGE_URL}/img/company-default-logo.svg`
export const CCP_STATUS = 1
export const OCI_STATUS = 2
export const CCP_OCI_STATUS = 3

export const GOOGLE_MAP_URL = 'https://www.google.com/maps'
